import { useEffect, useState } from "react";
import { useAppDispatch } from "../app/hooks";
import { constructUser, getAuthSession } from "../features/user/userAPI";
import { setUser, signOut, unsetUser } from "../features/user/userSlice";

const useAuth = () => {
  const dispatch = useAppDispatch();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    getAuthSession()
      .then((_session) => {
        setIsLoggedIn(true);
        constructUser().then((user) => {
          user && dispatch(setUser(user));
        });
      })
      .catch(() => {
        setIsLoggedIn(false);
        dispatch(unsetUser());
      });
  }, [dispatch]);

  const logOut = () => dispatch(signOut);

  return {
    isLoggedIn,
    logOut,
  };
};

export default useAuth;
